import { fetchAuxillaryBalances, fetchUserBalances } from '$lib/apis/main';
import { auxillartTokensToBeFetched } from '$lib/home/scwallet/config';
import { smartContractWalletAddress } from '$lib/home/scwallet/store';
import {
	firstLoadedUserBalances,
	loadingAuxillaryBalance,
	loadingNativeUserBalances,
	loadingUserBalances,
	nativeUserBalances,
	userBalances
} from '$lib/home/store';
import { addErrorNotification } from '$lib/notifications/notificationManager';
import { optimismTokensConfig } from '$lib/tokensConfig';
import type { AuxillaryTokenBalance, Token, TokenSymbol } from '$lib/types/tokens';
import { walletAddress } from '$lib/wallet/store';
import { get } from 'svelte/store';

export async function getUserBalances() {
	if (get(smartContractWalletAddress) === '' || get(walletAddress) === '') {
		return;
	}
	try {
		loadingUserBalances.set(true);
		const data: Array<Token> = (await fetchUserBalances(
			get(smartContractWalletAddress)
		)) as Token[];

		let balances: Record<TokenSymbol, Token> | Record<string, never> = {};
		if (get(userBalances)) {
			balances = get(userBalances);
		}
		data.forEach((e) => {
			balances[e.synth] = e;
			if (optimismTokensConfig[e.synth]) {
				balances[e.synth] = { ...e, ...optimismTokensConfig[e.synth] };
			}
		});
		userBalances.set(balances);
		loadingUserBalances.set(false);
		firstLoadedUserBalances.set(true);

		loadingNativeUserBalances.set(true);
		const dataNativeUser: Array<Token> = (await fetchUserBalances(get(walletAddress))) as Token[];

		let balancesNativeUser: Record<TokenSymbol, Token> | Record<string, never> = {};
		dataNativeUser.forEach((e) => {
			balancesNativeUser[e.synth] = e;
			if (optimismTokensConfig[e.synth]) {
				balancesNativeUser[e.synth] = { ...e, ...optimismTokensConfig[e.synth] };
			}
		});
		nativeUserBalances.set(balancesNativeUser);
		loadingNativeUserBalances.set(false);
	} catch (e) {
		addErrorNotification(
			'Failed to load data',
			'An error occurred while fetching data. Please refresh the page.',
			'An error occurred while fetching data. Please refresh the page.',
			true
		);
	}
	getAuxillaryNativeBalances();
	getAuxillaryBalances();
}

export async function getAuxillaryBalances() {
	const _smartContractWalletAddress = get(smartContractWalletAddress);
	const _walletAddress = get(walletAddress);
	if (!_smartContractWalletAddress || !_walletAddress) {
		return;
	}
	try {
		loadingAuxillaryBalance.set(true);
		const data: Array<AuxillaryTokenBalance> = (await fetchAuxillaryBalances(
			_smartContractWalletAddress
		)) as AuxillaryTokenBalance[];
		if (data && data.length > 0) {
			let balances: Record<TokenSymbol, Token> = get(userBalances);
			if (balances) {
				auxillartTokensToBeFetched.forEach((e) => {
					let auxillaryToken = data.find(
						(t) => t.tokenAddress == optimismTokensConfig[e].address && t.network == 'optimism'
					);

					if (auxillaryToken && optimismTokensConfig[e]) {
						balances[e] = {
							synth: e,
							balance: auxillaryToken.balance,
							balanceUSD: '0',
							...optimismTokensConfig[e]
						};
					}
				});
				userBalances.set(balances);
			}
		}
		loadingAuxillaryBalance.set(false);
	} catch (e) {
		loadingAuxillaryBalance.set(false);
	}
}

export async function getAuxillaryNativeBalances() {
	const _walletAddress = get(walletAddress);
	if (!_walletAddress) {
		return;
	}

	try {
		loadingNativeUserBalances.set(true);
		const data: Array<AuxillaryTokenBalance> = (await fetchAuxillaryBalances(
			_walletAddress
		)) as AuxillaryTokenBalance[];
		if (data && data.length > 0) {
			let balances: Record<TokenSymbol, Token> = get(nativeUserBalances);
			if (balances) {
				auxillartTokensToBeFetched.forEach((e) => {
					let auxillaryToken = data.find(
						(t) => t.tokenAddress == optimismTokensConfig[e].address && t.network == 'optimism'
					);

					if (auxillaryToken && optimismTokensConfig[e]) {
						balances[e] = {
							synth: e,
							balance: auxillaryToken.balance,
							balanceUSD: '0',
							...optimismTokensConfig[e]
						};
					}
				});
				nativeUserBalances.set(balances);
			}
		}
		loadingNativeUserBalances.set(false);
	} catch (e) {
		loadingNativeUserBalances.set(false);
	}
}
